import { render, staticRenderFns } from "./FansList.vue?vue&type=template&id=23796973&"
import script from "./FansList.vue?vue&type=script&lang=js&"
export * from "./FansList.vue?vue&type=script&lang=js&"
import style0 from "../style.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports